import { User, Users, Move, Video } from 'lucide-react';
import { courtFacilities } from '../../engine';
import { useT } from '../../i18n';

export interface CourtFacilityIconsProps {
  /** Court number (1-indexed); key into courtMeta for per-court overrides. */
  courtNum: number;
  /** Per-court metadata map ({ [courtNum]: { courtType, runoff, streaming, … } }). */
  courtMeta?: any;
  /** Global facility defaults applied where a court has no override. */
  courtDefaults?: any;
  /** Icon size in px (lucide `size`). */
  size?: number;
  /** Extra classes on the wrapping span. */
  className?: string;
}

/** Inline facility icons for a court (single/double, runoff, streaming); extracted verbatim from the monolith (legacy/App.tsx). */
export function CourtFacilityIcons({
  courtNum,
  courtMeta,
  courtDefaults,
  size = 13,
  className = '',
}: CourtFacilityIconsProps) {
  const t = useT();
  const f = courtFacilities(courtNum, courtMeta || {}, courtDefaults);
  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span
        title={t(
          f.courtType === 'single' ? 'booking.court.type.single' : 'booking.court.type.double',
        )}
        className="inline-flex items-center text-ink-3"
      >
        {f.courtType === 'single' ? <User size={size} /> : <Users size={size} />}
      </span>
      {f.runoff && (
        <span title={t('booking.court.runoff')} className="text-ink-3">
          <Move size={size} />
        </span>
      )}
      {f.streaming && (
        <span title={t('booking.court.streaming')} className="text-ink-3">
          <Video size={size} />
        </span>
      )}
    </span>
  );
}
